import { useState, useEffect, useRef } from 'react'
import styles from './LanguageSelector.module.scss'
import { LanguageIcon } from 'icons'

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'

const LanguageSelector = ({
  onChange,
  selected,
  translate,
  languages,
  desktopVersion,
  position
}) => {
  const [open, setOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const languageOptions = languages.map(lang => ({
    code: lang.code,
    label: translate(lang.name),
    name: lang.name
  }))

  return (
    <div
      className={styles.languageSelector}
      ref={ref}
    >
      {isMobile && !desktopVersion ? (
        <div className={styles.langMobile}>
          <div
            className={styles.langToggle}
            onClick={() => setOpen(!open)}
          >
            <img
              src={LanguageIcon}
              className={styles.languageIconMobile}
            />{' '}
            <span className={styles.languageTitle}>
              {open ? translate('language') + ':' : selected}
            </span>
          </div>
          {open && (
            <div className={styles.langOptionsMobile}>
              {languageOptions.map(option => (
                <div
                  key={option.code}
                  className={styles.langOptionMobile}
                  onClick={() => {
                    onChange(option.code)
                    setOpen(false)
                  }}
                >
                  {selected === option.name && <CheckOutlinedIcon style={{ width: '20px' }} />}{' '}
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.langDesktop}>
          <div
            className={styles.langToggle}
            onClick={() => setOpen(!open)}
          >
            <img src={LanguageIcon} /> {selected}
          </div>
          {open && (
            <div className={`${styles.langOptionsDesktop} ${styles[position]}`}>
              {languageOptions.map(option => (
                <div
                  key={option.code}
                  className={styles.langOption}
                  onClick={() => {
                    onChange(option.code)
                    setOpen(false)
                  }}
                >
                  {selected === option.name && <CheckOutlinedIcon style={{ width: '20px' }} />}{' '}
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default LanguageSelector
